import React from "react";
const url =
  "https://www.johnniewalker.com/inc/images/global/JohnnieWalkerFooter.svg";

function LogoWhite() {
  return (
    <div>
      <img src={url} alt="logo-white" />
    </div>
  );
}

export default LogoWhite;
